exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redaction-items{margin-top:8px;background-color:var(--component-background);border:1px solid var(--border);border-radius:4px}.redaction-items>:first-child{padding-top:16px}.redaction-items>:last-child{padding-bottom:16px}.redaction-page-group{padding-top:12px;padding-bottom:12px}.redaction-page-group-header{display:flex;justify-content:space-between;align-items:baseline}.redaction-page-group-number{font-size:13px;color:var(--faded-text)}.expand-arrow{height:16px;cursor:pointer}.expand-arrow .Icon{width:12px;height:5px}", ""]);

// exports
